import * as React from "react";
import { useState } from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import "./style.css";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
});

function InputFileUpload(props) {
  const { setLogo, logo, title = "title", onChange = () => {}, value } = props;
  const [logoName, setLogoName] = useState(logo?.name || "");
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage]
  );

  React.useEffect(() => {
    if (logo instanceof File) {
      setLogoName(logo.name);
    }
  }, [logo]);

  const handleImageUpload = (event) => {
    const image = event.target.files[0];
    if (!image) return;
    setLogo(image);
    setLogoName(image.name);
  };

  return (
    <div>
      <Button
        component="label"
        variant="outline"
        startIcon={<CameraAltOutlinedIcon />}
        className="buttonUploadStyle"
        onChange={onChange}
        value={value}
        title={title}
      >
        <div
          style={{
            paddingRight: "65px",
            position: "relative",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {logoName ? `${logoName}` : t.MSG_UPLOAD}
        </div>
        <p className="BrowserText">{t.BROWSER}</p>
        <VisuallyHiddenInput type="file" onChange={handleImageUpload} />
      </Button>
    </div>
  );
}

export default InputFileUpload;
